export const MONTHS = [
	{
		name: 'Janeiro',
		nameEn: 'January',
		num: '1',
		stringNum: '01',
	},
	{
		name: 'Fevereiro',
		nameEn: 'February',
		num: '2',
		stringNum: '02',
	},
	{
		name: 'Março',
		nameEn: 'March',
		num: '3',
		stringNum: '03',
	},
	{
		name: 'Abril',
		nameEn: 'April',
		num: '4',
		stringNum: '04',
	},
	{
		name: 'Maio',
		nameEn: 'May',
		num: '5',
		stringNum: '05',
	},
	{
		name: 'Junho',
		nameEn: 'June',
		num: '6',
		stringNum: '06',
	},
	{
		name: 'Julho',
		nameEn: 'July',
		num: '7',
		stringNum: '07',
	},
	{
		name: 'Agosto',
		nameEn: 'Augus',
		num: '8',
		stringNum: '08',
	},
	{
		name: 'Setembro',
		nameEn: 'September',
		num: '9',
		stringNum: '09',
	},
	{
		name: 'Outubro',
		nameEn: 'October',
		num: '10',
		stringNum: '10',
	},
	{
		name: 'Novembro',
		nameEn: 'November',
		num: '11',
		stringNum: '11',
	},
	{
		name: 'Dezembro',
		nameEn: 'December',
		num: '12',
		stringNum: '12',
	},
]

export const SELECT_MONTHS_NUM = [
    {
		name: '01',
		value: '01'
	},
	{
		name: '02',
		value: '02'
	},
	{
		name: '03',
		value: '03'
	},
	{
		name: '04',
		value: '04'
	},
	{
		name: '05',
		value: '05'
	},
	{
        name: '06',
		value: '06'
	},
	{
		name: '07',
		value: '07'
	},
	{
		name: '08',
		value: '08'
	},
	{
		name: '09',
		value: '09'
	},
	{
		name: '10',
		value: '10'
	},
	{
		name: '11',
		value: '11'
	},
	{
		name: '12',
		value: '12'
	}
]